import { vouchersService } from '@/services/vouchers.service.js';

const state = {
  getVouchersOutput: null,
  getVoucherByIdOutput: null,
  createVoucherOutput: null,
  updateVoucherOutput: null,
  deleteVoucherByIdOutput: null,
  archiveVoucherByIdOutput: null,
  unarchiveVoucherByIdOutput: null
};

const mutations = {
  setGetVouchersOutput(state, payload) {
    state.getVouchersOutput = payload;
  },
  setGetVoucherByIdOutput(state, payload) {
    state.getVoucherByIdOutput = payload;
  },
  setCreateVoucherOutput(state, payload) {
    state.createVoucherOutput = payload;
  },
  setUpdateVoucherOutput(state, payload) {
    state.updateVoucherOutput = payload;
  },
  setDeleteVoucherByIdOutput(state, payload) {
    state.deleteVoucherByIdOutput = payload;
  },
  setArchiveVoucherByIdOutput(state, payload) {
    state.archiveVoucherByIdOutput = payload;
  },
  setUnarchiveVoucherByIdOutput(state, payload) {
    state.unarchiveVoucherByIdOutput = payload;
  }
};

const actions = {
  async getVouchers({ commit }, { input, isActive = null, experienceId = null, isArchived = null }) {
    try {
      const response = await vouchersService.getList(input, isActive, experienceId, isArchived);
      commit('setGetVouchersOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching vouchers list:', error);
      throw error;
    }
  },
  
  async getById({ commit }, id) {
    try {
      const response = await vouchersService.getById(id);
      commit('setGetVoucherByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching voucher by id:', error);
      throw error;
    }
  },
  
  async create({ commit }, data) {
    try {
      const response = await vouchersService.create(data);
      commit('setCreateVoucherOutput', response);
      return response;
    } catch (error) {
      console.error('Error creating voucher:', error);
      throw error;
    }
  },
  
  async update({ commit }, data) {
    try {
      const response = await vouchersService.update(data);
      commit('setUpdateVoucherOutput', response);
      return response;
    } catch (error) {
      console.error('Error updating voucher:', error);
      throw error;
    }
  },
  
  async deleteVoucherById({ commit }, id) {
    try {
      const response = await vouchersService.delete(id);
      commit('setDeleteVoucherByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error deleting voucher:', error);
      throw error;
    }
  },
  
  async archiveVoucherById({ commit }, id) {
    try {
      const response = await vouchersService.archive(id);
      commit('setArchiveVoucherByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error archiving voucher:', error);
      throw error;
    }
  },
  
  async unarchiveVoucherById({ commit }, id) {
    try {
      const response = await vouchersService.unarchive(id);
      commit('setUnarchiveVoucherByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error unarchiving voucher:', error);
      throw error;
    }
  }
};

const getters = {
  vouchers: state => state.getVouchersOutput?.data || [],
  voucher: state => state.getVoucherByIdOutput || null
};

export const vouchers = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

